<ion-content class="ion-text-center">
  <div>
    <h3>{{'Location Permission Required' | translate}}</h3>
    <h3 class="ion-text-center">
      <img src="../../../../assets/imgs/logo.png" alt="{{ 'Safe Check-in' | translate }}">
    </h3>
    <div *ngIf="!allowBackgroundLocation" [innerHTML]="'location_permission_text' | translate">
    </div>
  </div>
</ion-content>

<ion-footer class="ion-padding ion-no-border responsive-footer">
  <ion-button color="primary"
              expand="block"
              size="medium"
              mode="ios"
              fill="solid"
              [disabled]="processing"
              (click)="allow()">
    {{'Allow' | translate}}
    <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
  </ion-button>
  <ion-button color="medium"
              expand="block"
              size="medium"
              mode="ios"
              fill="solid"
              (click)="dismiss()">
    {{'No thanks' | translate}}
    <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
  </ion-button>
</ion-footer>
